const data = {
	"body": "<path fill=\"currentColor\" d=\"M20 20H4a2 2 0 0 1-2-2V5.913A2 2 0 0 1 4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2ZM4 7.868V18h16V7.868L12 13.2L4 7.868ZM4.8 6l7.2 4.8L19.2 6H4.8Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
